import { Button } from "@/components/ui/button";
import {
  Calculator,
  FileText,
  Users,
  Receipt,
  Building2,
  FileCheck,
  Lightbulb,
  RefreshCcw,
  Rocket,
} from "lucide-react";

const services = [
  {
    icon: Calculator,
    title: "Comptabilité récurrente",
    description:
      "Tenue de votre comptabilité au quotidien, saisie des écritures, rapprochements bancaires.",
  },
  {
    icon: FileText,
    title: "Bouclement de fin d'année",
    description:
      "Clôture annuelle des comptes, préparation du bilan et du compte de résultat.",
  },
  {
    icon: Users,
    title: "Gestion des salaires",
    description:
      "Établissement des fiches de paie, déclarations sociales (AVS, LPP, LAA, IJM), certificats de salaire.",
  },
  {
    icon: Receipt,
    title: "Déclarations TVA",
    description:
      "Préparation et dépôt de vos décomptes TVA auprès de l'AFC, suivi des délais.",
  },
  {
    icon: Building2,
    title: "Déclarations sociales",
    description:
      "Gestion complète des charges sociales, déclarations annuelles aux assurances.",
  },
  {
    icon: FileCheck,
    title: "Déclarations fiscales",
    description:
      "Préparation des déclarations d'impôts pour votre société et optimisation fiscale.",
  },
  {
    icon: Lightbulb,
    title: "Conseil fiscal",
    description:
      "Accompagnement sur la structure fiscale, planification et optimisation adaptée à votre situation.",
  },
  {
    icon: RefreshCcw,
    title: "Restructuration",
    description:
      "Transformation de raison individuelle en Sàrl/SA, fusions, scissions, accompagnement dans les changements de structure juridique.",
  },
  {
    icon: Rocket,
    title: "Création d'entreprise",
    description:
      "Accompagnement dans la création de votre société, inscription au registre du commerce, mise en place de la comptabilité.",
  },
];

const Services = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="services"
      className="py-10 md:py-14 bg-white"
      aria-labelledby="services-title"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-left mb-12 md:mb-16">
          <h2
            id="services-title"
            className="text-3xl md:text-4xl font-semibold text-gray-900 tracking-tight font-['Manrope']"
          >
            Services pour Sàrl, SA & Indépendants
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl">
            Un accompagnement complet à chaque étape de la vie de votre entreprise
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <article
              key={service.title}
              className="service-card group p-6 md:p-8 bg-white border border-gray-200 rounded-xl hover:border-blue-600"
              data-testid={`service-card-${index}`}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-blue-50 mb-5">
                <service.icon
                  className="w-6 h-6 text-blue-600"
                  strokeWidth={1.5}
                  aria-hidden="true"
                />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 font-['Manrope'] mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 md:mt-16 text-center">
          <Button
            onClick={scrollToContact}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 py-6 text-base font-medium btn-primary"
            data-testid="services-cta-btn"
          >
            Discutons de vos besoins
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
